/*
 * App.tsx contains all top-level code that runs in prod and test.
 * For prod-only code, see start.tsx
 * For global-unit-test-only code see utils/test/specs.js
 * For individual-unit-test-only code see utils/test/render.js
 */
import UIApplication from 'UIComponents/app/UIApplication';
import ErrorBoundary from './components/Utilities/ErrorBoundary';
import FullPageError from './components/Utilities/FullPageError';
// @ts-ignore untyped module
import NotificationList from 'ReduxMessenger/components/NotificationList';

// DFC
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';

// Redux
import configureStore from './utils/configureStore';
import { Provider } from 'react-redux';

// Router
import { Router } from 'quartz-routing/react-router';

// Rhumb
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';

// Raven
import Raven from 'raven-js';
import { checkoutRavenDataCallback } from './utils/raven';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
Raven.setDataCallback(checkoutRavenDataCallback);
export const App = ({
  // Our rhumb implementation leads to history complications.  See in-depth comment on history & routing [in the PR](https://git.hubteam.com/HubSpotProtected/payments-ui/pull/281#discussion_r1782115).
  history = {},
  initialState = {},
  children = /*#__PURE__*/_jsx("div", {}),
  enableAnimationFeatures = true
} = {}) => {
  return /*#__PURE__*/_jsx(UIApplication, {
    name: "payments-ui-app",
    enableAnimationFeatures: enableAnimationFeatures,
    children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: new DataFetchingClient({
        assumeImmutableResults: true
      }),
      children: /*#__PURE__*/_jsx(Provider, {
        store: configureStore(initialState),
        children: /*#__PURE__*/_jsx(RhumbProvider, {
          config: rhumbConfig,
          history: historyAdapter(history),
          children: /*#__PURE__*/_jsx(Router, {
            history: history,
            children: /*#__PURE__*/_jsxs(ErrorBoundary, {
              boundaryName: "payments-ui",
              ErrorComponent: FullPageError,
              showRefreshAlert: false,
              children: [children, /*#__PURE__*/_jsx(NotificationList, {})]
            })
          })
        })
      })
    })
  });
};